import DataType from '@opsbase/lib-datatype/DataType';
import Pages from '@opsbase/lib-pages';
import AppPage from '@opsbase/web-app/AppPage';
import DVLPage from '@opsbase/web-dvl-page';
import React from 'react';
import OrgTemplateMenu from '../menus/OrgTemplateMenu';
import OrgTemplateSelectionToolbar from '../toolbars/OrgTemplateSelectionToolbar';
export function AdvancedOpTemplatesPage() {
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { viewId: DataType.ORGTEMPLATE, itemPage: Pages.ORG_TEMPLATE_EDIT, itemCreatePage: Pages.ORG_TEMPLATE_CREATE, itemMenu: OrgTemplateMenu, itemSelectionToolbar: React.createElement(OrgTemplateSelectionToolbar, null), disableCharts: true, disableFieldSelection: true })));
}
export default AdvancedOpTemplatesPage;
